import initialState from './initialState'
import {SEND_EMAIL,SENT_EMAIL} from '../actions/actionTypes'

export default function emails(state = initialState.emails, action) {
	switch (action.type) {
	case SEND_EMAIL:
		return {
			...action,
			isSending: true
		}
	case SENT_EMAIL:
		return {
			...action,
			isSending: false
		}
	default:
		return state
	}
}


// WEBPACK FOOTER //
// ./src/redux/reducers/emails.js